
/* ^^^ sub-component filenames use dots to denote hierarchy */
import { SortDirection } from "../../constants";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
// import { PassesExtraProps } from "../decorators";

const { ASC, DESC } = SortDirection;

export default class TableHeader extends React.Component {

    static defaultProps = {
        _isCurrentSortHeader: false,
        _sortDirection: ASC,
    };

    static propTypes = {
        _isCurrentSortHeader: PropTypes.bool, // injected prop
        _onSort: PropTypes.func, // injected prop
        _sortDirection: PropTypes.oneOf(Object.values(SortDirection)), // injected prop
        sortKey: PropTypes.string,
    };

    get isSortable() {
        return Boolean(this.props.sortKey);
    }

    handleClick = () => {
        const { _onSort, sortKey } = this.props;
        if (this.isSortable && _onSort) {
            _onSort(sortKey);
        }
    }

    get className () {
        const { className, _isCurrentSortHeader, _sortDirection } = this.props;
        return classnames(className, {
            "sortable": this.isSortable,
            "sort-asc": _isCurrentSortHeader && _sortDirection === ASC,
            "sort-desc": _isCurrentSortHeader && _sortDirection === DESC,
        });
    }

    render = () =>
        <th {...this.extraProps} className={this.className} onClick={this.handleClick}>
            {this.props.children}
        </th>
}
